import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberFormatter'
})
export class NumberFormatterPipe implements PipeTransform {

  transform(value: number | string): string {
    if (value === null || value === undefined) return '';
    const numberValue = typeof value === 'number' ? value : parseFloat(value);
    return numberValue.toLocaleString('tr-TR')+' $';
  }
  transformPercentage(value: number | string): string {
    if (value === null || value === undefined) return '';
    const numberValue = typeof value === 'number' ? value : parseFloat(value);
    return numberValue.toLocaleString('tr-TR') + ' $';
  }

}
